interface DesktopProductHeaderProps {
  onBack: () => void;
}

export function DesktopProductHeader({ onBack }: DesktopProductHeaderProps) {
  return (
    <div className="bg-white border-b-2 border-gray-200">
      <div className="flex items-center px-8 py-6">
        <button
          onClick={onBack}
          className="flex items-center gap-3 text-[18px] text-gray-600 hover:text-gray-800 transition-colors"
        >
          <img src="/icons/icon_back.svg" alt="뒤로 가기" width="28" height="28" />
          <span className="font-medium">뒤로 가기</span>
        </button>
        
        <div className="flex-1 text-center">
          <h1 className="text-2xl font-bold text-gray-900">상품 상세</h1>
        </div>
        
        <div className="w-[100px]"></div> {/* Balance spacing */}
      </div>
    </div>
  );
}